module.exports = __webpack_public_path__ + "static/media/empty_tasks.ba5209ff.png";